import { Copy, Stack } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { CreditAvailabilityLayout } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/DurationsRule/CreditAvailabilityLayout/CreditAvailabilityLayout';
import { CreditFrequencyLayout } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/DurationsRule/CreditFrequencyLayout/CreditFrequencyLayout';
import { useGetDurationsAvailabilityInfo } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/DurationsRule/hooks/useGetDurationsAvailabilityInfo';
import { useSetExpiresOnSelect } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/DurationsRule/hooks/useSetExpiresOnSelect';

export function DurationsRuleBody({
  isActive,
}: {
  isActive: boolean;
}): JSX.Element {
  const { availabilityInfo } = useGetDurationsAvailabilityInfo();

  useSetExpiresOnSelect({ isActive });

  return (
    <>
      <Stack y="sm">
        <CreditFrequencyLayout />
      </Stack>
      <Stack y={availabilityInfo ? 'sm' : 'none'}>
        <CreditAvailabilityLayout />
      </Stack>
      {availabilityInfo && <Copy variant="body">{availabilityInfo}</Copy>}
    </>
  );
}
